// @flow
import React from "react";
import {Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader, Progress} from "reactstrap";

export type GenericModalStateProps = {
    promptMsg: string,
    loadingMsg: string,
    open: boolean,
    isLoading: boolean,
    error: any,
    primaryActionText: string,
    primaryActionClassName?: string,
    args: any,
    primaryActionColor: string
};

export type GenericModalDispatchProps = { closeModal: () => any, primaryAction: (args: any) => any };

export type GenericModalOwnProps = { children: any };

type GenericModalProps = GenericModalStateProps & GenericModalDispatchProps & GenericModalOwnProps;

export default function GenericModal(props: GenericModalProps) {

    return (

        <Modal isOpen={props.open} toggle={() => {

            if (!props.isLoading) {
                props.closeModal();
            }
        }}>
            <ModalHeader toggle={() => {

                if (!props.isLoading) {
                    props.closeModal();
                }
            }}>Warning</ModalHeader>
            <ModalBody>
                {
                    !props.isLoading && !props.error &&
                    <span>{props.promptMsg}</span>
                }
                {
                    !props.isLoading && props.error &&
                    <Alert color={"danger"}>{typeof props.error === "string" ? props.error : "Failed. Please try again!"}</Alert>
                }
                {
                    props.isLoading &&
                    <span>{props.loadingMsg}</span>
                }

                {
                    props.isLoading &&

                    (<Progress animated color="danger" value="100"/>)
                }
            </ModalBody>
            <ModalFooter>
                {
                    !props.isLoading && !props.error &&

                    [<Button key={1} className={props.primaryActionClassName} color={props.primaryActionColor} onClick={() => {
                        props.primaryAction(props.args);
                    }}>{props.primaryActionText}</Button>,
                        <Button key={2} color="secondary" onClick={() => {
                            props.closeModal();
                        }}>Cancel</Button>]
                }

            </ModalFooter>
        </Modal>
    )
}



// WEBPACK FOOTER //
// ./src/components/GenericModal.js